import React, { Fragment } from 'react';
import { Provider } from 'react-redux';
import { MuiThemeProvider, StylesProvider, createGenerateClassName } from '@material-ui/core/styles';

import history from './routes/history';
import store from './store';
import theme from './theme';
import { LibraryLayout } from './containers/Layouts';
import { setSolargrafPopupDetails } from './containers/Layouts/actions';
import AccountListMenu from './components/AccountList';
import { Header, ThirdParty, Homeowner, Distributor } from './components/Header';
import {
  GoToSolargrafPopup as GoToSolargraf,
  KnowMorePopup as KnowMore,
  LinkWithSolargrafPopup as LinkWithSolargraf,
  MeasurementPendingDialog as MeasurementPending,
  RedirectionConfirmPopup as RedirectionConfirm,
  SolargrafPopupFlow as SolargrafFlow
} from './components/Solargraf';
import { Footer, FooterWithoutLanguageSwitch, FooterWithoutLanguageSwitchSG } from './components/Footer';
import CreateSystem from './containers/CreateSystem';
import AddressField from './components/AddressField';
import { Breadcrumbs } from './components/Breadcrumb';
export * from './components/Breadcrumb/constant';

const generateClassName = createGenerateClassName({
  productionPrefix: 'common-ui',
  disableGlobal: true
});

function ThemeStoreWrapper(props) {
  const { children = <Fragment /> } = props;
  return (
    <StylesProvider generateClassName={generateClassName}>
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>{children}</Provider>
      </MuiThemeProvider>
    </StylesProvider>
  );
}

export const DefaultHeader = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={Header} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const ThirdPartyHeader = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={ThirdParty} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const DistributorHeader = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={Distributor} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const HomeownerHeader = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={Homeowner} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const DefaultFooter = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={Footer} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const FooterWithoutLanguage = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={FooterWithoutLanguageSwitch} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const FooterWithoutLanguageSG = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={FooterWithoutLanguageSwitchSG} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const AccountList = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={AccountListMenu} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const GoToSolargrafPopup = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={GoToSolargraf} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const KnowMorePopup = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={KnowMore} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const LinkWithSolargrafPopup = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={LinkWithSolargraf} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const MeasurementPendingDialog = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={MeasurementPending} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const RedirectionConfirmPopup = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={RedirectionConfirm} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const SolargrafPopupFlow = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={SolargrafFlow} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const CreateSystemFlow = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={CreateSystem} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const AddressFieldFlow = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={AddressField} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const Breadcrumb = props => {
  return (
    <ThemeStoreWrapper>
      <LibraryLayout component={Breadcrumbs} {...history} {...props} />
    </ThemeStoreWrapper>
  );
};

export const setSolargrafDetails = payload => store.dispatch(setSolargrafPopupDetails(payload));
